import {
  BuildingType,
  CreateBuildingInput,
  CreateBuildingPartInput,
  UpdateBuildingInput,
  UpdateBuildingPartInput,
} from '../../../generated/graphql'
import { parseDecimal } from '../../../util/parsers'

type PartFormValueBase = {
  id: string
  area: string
}

export type CreatePartFormValue = PartFormValueBase & {
  templateId: string
}

export type UpdatePartFormValue = PartFormValueBase & {
  name: string
}

export type FormValues = {
  name: string
  area: string
  type: BuildingType
  multiplier: string
  demandHourSeriesIds: string[]
  createdParts: CreatePartFormValue[]
  updatedParts: UpdatePartFormValue[]
}

export function mapFormValuesToBuildingInput<TIsUpdate extends boolean>(
  values: FormValues,
  isUpdate: TIsUpdate,
): TIsUpdate extends true ? UpdateBuildingInput : CreateBuildingInput
export function mapFormValuesToBuildingInput(
  values: FormValues,
  isUpdate: boolean,
): CreateBuildingInput | UpdateBuildingInput {
  const mapPartFormValueToCreateInput = (
    part: CreatePartFormValue,
  ): CreateBuildingPartInput => ({
    templateId: part.templateId,
    area: Number(part.area),
  })

  const mapPartFormValueToUpdateInput = (
    part: UpdatePartFormValue,
  ): UpdateBuildingPartInput => ({
    id: part.id,
    area: Number(part.area),
  })

  const buildingInput = {
    name: values.name,
    area: parseDecimal(values.area),
    type: values.type,
    multiplier: parseDecimal(values.multiplier),
    demandHourSeriesIds: values.demandHourSeriesIds,
    createdParts: values.createdParts?.map(mapPartFormValueToCreateInput) ?? [],
  }

  return isUpdate
    ? {
        ...buildingInput,
        updatedParts:
          values.updatedParts?.map(mapPartFormValueToUpdateInput) ?? [],
      }
    : { ...buildingInput }
}
